/* @flow */
import React from 'react';

import Table from 'components/UIKit/Table';
import CaseOverviewColumns from './CaseOverviewColumns';
import CaseOverviewRows from './CaseOverviewRows';

type CaseOverviewTableProps = {
  router: Object,
  children: any
}

export default function CaseOverviewTable({
  children, router
}: CaseOverviewTableProps): React.Element {
  return (
    <Table>
      <CaseOverviewColumns />
      <CaseOverviewRows router={router}>
        {children}
      </CaseOverviewRows>
    </Table>
  );
}
